import cn from 'classnames'

export default cn
